export * from './sub-rule-my-suffix-detail.component';
export * from './sub-rule-my-suffix-update.component';
export * from './sub-rule-my-suffix.route';
export * from './sub-rule-my-suffix.service';

